import { ControlSchemaType } from '../ControlTypes';
import { StudyStatusEnum } from '@dynamika-shared/types/status';
import { draft } from './draft';
import { startUp } from './startUp';

export const uiControlSchemas: Record<StudyStatusEnum, ControlSchemaType> = {
    [StudyStatusEnum.draft]: draft,
    [StudyStatusEnum.startUp]: startUp,
    [StudyStatusEnum.onHold]: startUp,
    [StudyStatusEnum.cancelled]: startUp,
    [StudyStatusEnum.completed]: startUp,
    [StudyStatusEnum.closeUp]: startUp,
    [StudyStatusEnum.maintenance]: startUp,
};
